import pbkdf2 from 'pbkdf2';
import hkdf from 'futoin-hkdf';
import forge from 'node-forge';

export const generateKey = (I, P, S) => {
    const salt = S;
    const hash = 'SHA-256';
    const derived_salt = hkdf(I, 32, { salt, hash }).toString('hex');
    return forge.util.createBuffer(pbkdf2.pbkdf2Sync(P, derived_salt, 10000, 32, 'sha256'));
}